// JS
import '../../custom/js/index';

// Base SCSS
import '../../custom/scss/base.scss';
import '../../custom/scss/layout.scss';

// Compponents JS
import '~/src/custom/js/pagebuilder';
import '~/src/custom/js/components/pagebuilder';
import '~/src/custom/js/components/office-page';
import '~/src/custom/js/components/office-page-testimonial';
import '~/src/custom/js/components/office-form-modal';
import '~/src/custom/js/components/formbuilder';

// Components SCSS
import '~/src/custom/scss/pagebuilder.scss';
import '../../custom/scss/components/office/office.scss';
import '../../custom/scss/components/hero/hero-office.scss';
import '../../custom/scss/components/office-testimonial/office-testimonial.scss';
import '../../custom/scss/components/office/office-map.scss';
import '../../custom/scss/components/modal/modal-contact-form.scss';

// import Vue App
import Vue from 'vue';
import VueApp from '../../custom/vue/custom-apps/map-office-filter';
import App from '../../custom/vue/custom-apps/containers/map-office.vue';

// connect vue component and init app
Vue.component('app', App);
VueApp.$mount('#office-map');
